// ==================== APP CONFIG ====================
// Source of truth for pricing, URLs, and feature flags.
// StudioLandingPage.jsx imports from here.
// marketing.html is static — update manually (note in that file references this).

export const CONFIG = {
  // Polar
  CHECKOUT_URL: 'https://buy.polar.sh/polar_cl_MH5WZbgpgYA160Stodgu35CFhH4Y38JKOOo9o3y1MWA',
  POLAR_ORG_ID: '4023fbb0-fc65-4c00-bd07-74fdea29377c',

  // Pricing
  LAUNCH_PRICE: 29,
  FULL_PRICE: 49,
  TRIAL_DAYS: 14,

  // External
  FORMSPREE_ID: 'mlgwjzlq',

  // Feature flags
  COACHING_ENABLED: true,
  MIDI_EXPORT_ENABLED: false,
};
